import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Dropdown, DropdownButton} from "react-bootstrap";
import './memorization-container.css';
import { IMemorizationChapter } from '../../models/memorization-chapter';
import { IMemorization } from '../../models/memorization';
import { MemorizationChapterViewTable } from './memorization-chapter-view-table';



export interface IMemorizationHomeWorkViewModal {
   memorization: IMemorization;
   showModal: boolean;
   onHideModal: () => void;
}

function MemorizationHomeWorkViewModal(props: IMemorizationHomeWorkViewModal) {

   const {showModal, memorization,  onHideModal} = props;
   
   const [show, setShow] = useState(showModal);
   const [selectedMemorizationGrade, setMemorizationGrade] = useState(memorization.memorizationGrade);
   const [selectedRepetitionGrade, setRepetitionGrade] = useState(memorization.repetitionGrade);

   const [memorizationChaptersState, setMemorizationChapters] = useState(memorization.memorizationChapters 
    ? memorization.memorizationChapters : [] as IMemorizationChapter[]);

   useEffect(()=>{
      setShow(showModal);
   },[showModal])

   useEffect(()=>{
    if(memorization.memorizationChapters)
    {
      setMemorizationChapters(memorization.memorizationChapters);
    }
 },[memorization.memorizationChapters])

 useEffect(()=>{
  if(memorization.memorizationGrade){
    setMemorizationGrade(memorization.memorizationGrade.toString());
  }
},[memorization.memorizationGrade])

useEffect(()=>{
  if(memorization.repetitionGrade){
     setRepetitionGrade(memorization.repetitionGrade.toString());
  }
},[memorization.repetitionGrade])


   const handleClose = () => 
   {
      setShow(false);
      setMemorizationChapters([]);
      onHideModal();
   };

   const getGradeName = (selectedElement: string)=> {
    switch(selectedElement){
      case "1":
        return "Perfekt";
      case "2":
        return "Meget godt";
      case "3":
        return "Godt";
      case "4":
        return "Har ikke memoriseret";
    }
  }

  return (
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title style={{  fontFamily: 'Heiti SC, sans-serif',
            fontWeight: "400",
            fontSize:"20px",
            color:"#000"}}>Memorering/Repetition lektie</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div>
         <div>  
          {
            memorization.teacher && <label style={{marginBottom: "20px", fontFamily: 'Heiti SC, sans-serif', fontSize:"16px"}}>Lære: {memorization.teacher.fullName}</label>
          }
    
          { memorizationChaptersState && <div>
             <MemorizationChapterViewTable 
                memorizationChapters={memorizationChaptersState}
                />
              </div>}
              <br></br>
              {<label style={{
            marginTop:"0px",
            marginBottom: "10px",  
            marginLeft: "0px", 
            fontFamily: 'Heiti SC, sans-serif',
            fontWeight: "500",
            fontSize:"18px",
            color:"#000"}}>Karakter</label>}
              { <div style={{display: "flex" ,marginBottom: "10px"}}>
              <br></br>
            <label style={{marginBottom: "10px", fontFamily: 'Heiti SC, sans-serif', fontSize:"16px"}}>Memorering:</label>
            { <DropdownButton disabled={true} className="custom-dropdown2"  style={{marginLeft: "10px", marginTop: "-5px"}} key="dropdownkey" 
            id="dropdown-basic-button" title={!selectedMemorizationGrade ? "Vælg karakter" : getGradeName(selectedMemorizationGrade)}>
              <Dropdown.Item eventKey="1">Perfekt</Dropdown.Item>
              <Dropdown.Item eventKey="2">Meget godt</Dropdown.Item>
              <Dropdown.Item eventKey="3">Godt</Dropdown.Item>
              <Dropdown.Item eventKey="4">Har ikke memoriseret</Dropdown.Item>
            </DropdownButton>
            }
          </div>}
              <br></br>
            { <div style={{display: "flex" ,marginBottom: "10px"}}>
              <br></br>
            <label style={{marginBottom: "10px", fontFamily: 'Heiti SC, sans-serif', fontSize:"16px"}}>Repetition:</label>
            { <DropdownButton disabled={true} className="custom-dropdown2"  style={{marginLeft: "25px", marginTop: "-5px"}} key="dropdownkey" 
            id="dropdown-basic-button" title={!selectedRepetitionGrade ? "Vælg karakter" : getGradeName(selectedRepetitionGrade)}>
              <Dropdown.Item eventKey="1">Perfekt</Dropdown.Item>
              <Dropdown.Item eventKey="2">Meget godt</Dropdown.Item>
              <Dropdown.Item eventKey="3">Godt</Dropdown.Item>
              <Dropdown.Item eventKey="4">Har ikke memoriseret</Dropdown.Item>
            </DropdownButton>
            }
          </div>}
          </div>
      
          <br></br>
          </div>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{backgroundColor:"#197770", fontFamily: 'Heiti SC, sans-serif', fontSize:"14px"}} variant="secondary" onClick={handleClose}>
              Luk
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}

export default MemorizationHomeWorkViewModal;